import { Restriction as NumberRestriction } from "./Restriction";
export var Number;
(function (Number) {
    Number.Restriction = NumberRestriction;
})(Number || (Number = {}));
//# sourceMappingURL=index.js.map